import { put, takeLatest } from "redux-saga/effects";
import {
  fetchCityFailed,
  fetchCityStart,
  fetchCitySuccess,
} from "./postNumberSlice";

import { isOfflineMode } from "Utils/isOfflineMode";
import axiosJsonp from "axios-jsonp-pro";
import { PostNumberCity, PostNumberError } from "./postNumberInterfaces";

async function fetchCity(payload: string): Promise<PostNumberCity> {
  const url = `https://api.bring.com/shippingguide/api/postalCode.json?clientUrl=www.storebrand.no&pnr=${payload}`;
  // Stub if running as E2E tests.
  if (isOfflineMode()) {
    return Promise.resolve({
      result: "HALDEN",
      valid: true,
    });
  }
  // Old and deprecated API:
  const axiosResponse = await axiosJsonp.jsonp<PostNumberCity>(url);
  return axiosResponse as unknown as PostNumberCity;
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* getCityFromPostNumberStart({
  payload,
}: ReturnType<typeof fetchCityStart>) {
  try {
    const { result, valid } = yield fetchCity(payload);
    yield put(fetchCitySuccess({ result, valid } as PostNumberCity));
  } catch (error) {
    yield put(
      fetchCityFailed(
        (error as Record<string, unknown>).message as PostNumberError,
      ),
    );
  }
}

export function* postNumberSaga(): Generator {
  yield takeLatest(fetchCityStart, getCityFromPostNumberStart);
}
